import { getCore } from '../../../../client/core/getCore';
import { getDefaultClient } from '../../../../client/defaultClient';
import { createApiClient } from '../../../apiClient';

/**
 * Retrieves all passkeys associated with the current user.
 *
 * This function fetches the list of registered passkeys (WebAuthn credentials)
 * that the user can use for multi-factor authentication.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to an array of the user's registered passkeys.
 */
export const getPasskeys = async (client = getDefaultClient()) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const response = await apiClient.getUserPasskeys({
    environmentId: core.environmentId,
  });

  return response.passkeys;
};
